import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { Box } from "@mui/material";
import { PRICE_LVL_COL_WIDTH } from "../constants/constants";

export function ColumnHeaderActionButtons({
  open,
  isDirty,
  handleSaveDropPrices,
  handleCancelPriceLevel,
}: ColumnHeaderActionButtonsProps) {
  const { classes } = useStyles();

  if (!open) {
    return null;
  }

  return (
    <Box className={classes.colActionBox}>
      <MiButton
        title="Save"
        variant={BUTTON_VARIANTS.CONTAINED}
        onClick={handleSaveDropPrices}
        size="small"
        disabled={!isDirty}
      />
      <MiButton
        title="Cancel"
        variant={BUTTON_VARIANTS.TEXT}
        color={BUTTON_COLORS.BLACK}
        onClick={handleCancelPriceLevel}
        size="small"
        className={classes.cancelButton}
      />
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  colActionBox: {
    position: "absolute",
    left: PRICE_LVL_COL_WIDTH,
    top: 0,
    backgroundColor: theme.palette.common.white,
    padding: 8,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    zIndex: 1,
    borderRadius: 4,
    height: 38,
    borderTop: `1px solid ${theme.palette.divider}`,
    boxShadow: `0px 2px 2px ${theme.palette.grey.darkAccent}`,
  },
  cancelButton: {
    textDecoration: "underline",
  },
}));

interface ColumnHeaderActionButtonsProps {
  open: boolean;
  isDirty: boolean;
  handleSaveDropPrices: () => void;
  handleCancelPriceLevel: () => void;
}
